export interface InactivityRateData {
  deregistration_rate: number;
  total_processes: number;
  mes: string;
  year: number;
  ranking: string;
  internal_limit: number;
  internal_limit_requested: number;
  processes_first_session_30d: number;
  second_session_30d: number;
  fifth_session_pct: number;
  bloqueos: string;
  nombre: string;
}

const INACTIVITY_WEBHOOK = 'https://hook.us1.make.com/othkc4aes5o5v84i3734h5f1r7lokaum';
const DETAIL_WEBHOOK   = 'https://hook.us1.make.com/e1x36t6iv4vuuhxue7bvitleayff9fgh';

export async function fetchInactivityRate(
  psychologistId: string,
  month: string, // YYYY-MM
): Promise<InactivityRateData> {
  const url = `${INACTIVITY_WEBHOOK}?psychologist_id=${encodeURIComponent(psychologistId)}&month=${month}`;
  const res = await fetch(url, { signal: AbortSignal.timeout(10_000) });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

// ─── Detail webhook (3.2) ─────────────────────────────────────────────────────

export interface InactivityDetailProcess {
  process: string;                          // Airtable record ID del proceso
  patient_name: string | null;
  rol_en_calculo: string;                   // 'numerador' | 'denominador' | 'excluido_*' | 'alta_en_mes'
  total_sesiones: number;
  activation_date: string;                  // ISO — inicio del proceso
  ultima_sesion_date_absoluta: string | null; // ISO — última sesión
  patient_status_actual: string | null;     // 'active' | 'inactive' | null
  patient_status_al_fin: string | null;
  es_reactivado: 0 | 1;
  es_baja_prematura: boolean | null;
  fecha_baja: string | null;
  deregistration_date: string | null;
  gap_dias: number | null;
  es_transferred_en_mes: 0 | 1;
  segmento_actual: string | null;
  transito_a_dereg_en_mes: boolean | null;
}

export interface InactivityDetailData {
  mes: string;                               // "YYYY-MM"
  psico: string;
  denominador: number;
  numerador: number;
  excluidos_por_sesiones: number;
  procesos_vigentes: number;
  procesos_vigentes_reactivados: number;
  procesos_vigentes_transferred: number;
  procesos_alta_en_mes: number;
  procesos_alta_en_mes_vigentes: number;
  procesos_alta_en_mes_baja: number;
  deregistration_rate: string;              // "x.xx%"
  procesos: InactivityDetailProcess[];
}

// Para psicólogas en pending_discharged, fetchInactivityRate no las encuentra (fuera del roster
// activo que evalúa ese webhook), pero fetchInactivityDetail sí las procesa igual. numerador/
// denominador vienen del mismo cálculo que expone InactivityRateData.deregistration_rate, así que
// son la fuente confiable de reemplazo para ese caso puntual.
export function rateFromDetail(detail: InactivityDetailData): number {
  return detail.denominador > 0 ? detail.numerador / detail.denominador : 0;
}

export async function fetchInactivityDetail(
  psychologistId: string,
  month: string, // "MM"
  year: string,  // "YYYY"
): Promise<InactivityDetailData> {
  const res = await fetch(DETAIL_WEBHOOK, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ psychologist_id: psychologistId, month, year }),
    signal: AbortSignal.timeout(15_000),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}
